import { GET_CASHBACK } from "../../actions/type";
export default function cashback(state = {}, action) {
    switch (action.type) {
        case GET_CASHBACK:
            return action.payload;
        default:
            return state
    }
}